(() => {
  const initRail = (rail) => {
    if (!rail || rail.dataset.vfThumbArrowsReady === 'true') return;

    const list = rail.querySelector('.thumbnail-list');
    const up = rail.querySelector('[data-vf-thumb-scroll="up"]');
    const down = rail.querySelector('[data-vf-thumb-scroll="down"]');
    if (!list || !up || !down) return;

    rail.dataset.vfThumbArrowsReady = 'true';

    const update = () => {
      const max = Math.max(0, list.scrollHeight - list.clientHeight);
      up.disabled = list.scrollTop <= 2;
      down.disabled = list.scrollTop >= max - 2;
    };

    const move = (direction) => {
      const item = list.querySelector('.thumbnail-list__item');
      const itemHeight = item ? item.getBoundingClientRect().height : 82;
      const gap = 10;
      const amount = (itemHeight + gap) * 3;
      list.scrollBy({ top: direction * amount, behavior: 'smooth' });
    };

    up.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      move(-1);
    });

    down.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      move(1);
    });

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(update);
      ro.observe(list);
    }

    requestAnimationFrame(update);
    setTimeout(update, 250);
  };

  const initAll = () => {
    document.querySelectorAll('media-gallery > .thumbnail-slider').forEach(initRail);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('pageshow', initAll);
})();